import { Component, Input, OnInit, HostListener, EventEmitter, Output } from '@angular/core';
import { Utils } from 'src/app/tools/utils';
import { Router } from '@angular/router';
import { Roles, IxellAPIService, SearchResponseFormula, FormulaVersion, FormulaLayer, SearchResponseVariants, Variants, Tarif, Results, SearchResponseMarket, Retour_DLL_PAE, IxellColorWebPAE, FormulaComponent } from '../../tools/api.service';
import { StorageService } from 'src/app/tools/storage.service';
import { SearchCrit } from 'src/app/entities/searchCrit';
import { HeaderService } from 'src/app/tools/header.service';
import { SearchCritMixitCloud } from '../../entities/searchCritMixitCloud';
import { SearchResultMixitCloud } from '../../entities/searchResultMixitCloud';
import { DilutionPAEEquinox, RowDilutionPAEEquinox } from '../../entities/dilutionPAEEquinox';

@Component({
    selector: 'formule',
    templateUrl: './formule.component.html',
    styleUrls: ['./formule.component.scss']
})


export class FormuleComponent implements OnInit {
    @Input() country: string;
    @Input() langue: string;
    @Input() searchCrit: SearchCritMixitCloud;
    @Input() formule: SearchResponseFormula;
    @Input() variantes: SearchResponseVariants;
    @Input() variante: Variants;
    @Input() teinteMeresSelected: SearchResponseMarket;
    @Output() resultLigneFormule = new EventEmitter<SearchResultMixitCloud>();
    @Output() outputLangue = new EventEmitter();

    role: Roles;

    listeLignePeinture: string[] = [];
    listeLignePeintureSelect: string[] = [];


    infoFormule: string;
    nomFormule: string;

    qte: number = 1;
    isCtc: boolean = false;
    versionFormuleCourante: FormulaVersion;
    coucheFormuleCourante: FormulaLayer;
    coucheFormuleCourantePAE: FormulaLayer;
    activeCouchePrimer: string;
    activeCouche1: string;
    activeCouche2: string;
    indexVersionFormuleCourante: number = -1;
    indexVersionFormuleCouranteCouche: number = -1;
    indexLignePeintureCourante: number = 0;
    lignePeinture: string = "";
    tarif: Tarif;
    libTarif: string = "";
    category: string = "";
    listCategorie: string[] = [];
    qrcode: string;
    infoQRCode: string;
    uniteSelected: string = "L";
    densiteFormule: number = 1;

    /* PAE */
    retour_DLL_PAE_initial: Retour_DLL_PAE;
    retour_DLL_PAE: Retour_DLL_PAE;
    listChoixVernis: string[] = [];
    seeListChoixVernis: boolean = false;

    choixVernisPAE: string;
    choixDilutionVernisPAE: IxellColorWebPAE;

    ixellColorWebPAE: IxellColorWebPAE[] = [];
    ixellColorWebPAECourant: IxellColorWebPAE[] = [];
    listIdIxellColorWebPAEPrecedent: number[] = [];
    seeColorWebPAE: boolean = false;

    listChoixIxellColorWebPAE: IxellColorWebPAE[] = [];
    titlePAEDLL: string;
    subtitlePAEDLL: string;
    haveDilutionPAEDetailTitre: string;

    buttonCloseDilution: boolean = true;
    buttonPrevDilution: boolean = false;
    buttonNextDilution: boolean = false;
    haveDilutionPAE: boolean = false;

    haveDilutionPAE_quadrillage: boolean = false;
    haveDilutionPAE_vehicule: boolean = false;
    haveDilutionPAE_jauge: boolean = false;

    choixJaugeIxellColorWebPAE: IxellColorWebPAE;
    choixJaugeWithBoucleWhile: boolean;

    dilutionPAE_vehiculeSelected: boolean = false;

    densiteFormulePAE: number = 1;

    listChoixIxellColorWebPAEVehicule: DilutionPAEEquinox[] = [];

    displayedColumns = ["code", "name", "weight", "cumul"];
    displayedColumnsDillutionVehicule = ["valNPlus1", "unique", "lateral", "demi", "complet"];

    private searchSub: any;
    private categorySub: any;
    private roleSub: any;
    private tarifSub: any;
    private QRCodeSub: any;
    private statsLogCWTFormule: any;
    private paeSub: any;
    private paeDillutionSub: any;
    private paeGetDillutionSub: any;


    constructor(private router: Router, private apiService: IxellAPIService, private storage: StorageService, private headerService: HeaderService) { }

    @HostListener('window:popstate', ['$event'])
    onPopState(event: any) {
        this.headerService.changeBack(true);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * ngOnInit
     */
    ngOnInit(): void {

        /*----------------------------------------------------------------------------------------------------*/console.log("searchCrit : ", this.searchCrit);
        /*----------------------------------------------------------------------------------------------------*/console.log("formule : ", this.formule);
        /*----------------------------------------------------------------------------------------------------*/console.log("variantes : ", this.variantes);
        /*----------------------------------------------------------------------------------------------------*/console.log("variante : ", this.variante);
        /*----------------------------------------------------------------------------------------------------*/console.log("teinteMeresSelected : ", this.teinteMeresSelected);

        this.roleSub = this.headerService.currentRole.subscribe(role => {
            this.role = role;
            if (Utils.isCTC(this.role)) {
                this.isCtc = true;
                this.tarifSub = this.apiService.getTarifCtc(true).subscribe(data => {
                    this.tarif = data;
                    this.listCategorie = data.listCategorie;
                    if (this.tarif != null) {
                        this.libTarif = this.tarif.tar_lib;
                    }
                    if (this.tarifSub != null) this.tarifSub.unsubscribe();
                }, error => {
                    console.log(error);
                    if (this.tarifSub != null) this.tarifSub.unsubscribe();
                });

                this.categorySub = this.apiService.getCategoryCtc().subscribe(data => {
                    this.category = data;

                    if (data != "") {
                        this.displayedColumns.push("prix");
                    }
                    if (this.categorySub != null) this.categorySub.unsubscribe();
                }, error => {
                    console.log(error);
                    if (this.categorySub != null) this.categorySub.unsubscribe();
                });

            }
            if (this.roleSub != null) this.roleSub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.roleSub != null) this.roleSub.unsubscribe();
        });

        switch (this.variante.imitations[0].productId) {
            case "372":
                this.lignePeinture = "Equinox Solid";
                break;
            case "373":
                this.lignePeinture = "Equinox Waterbase";
                break;
        }

        var imitations = this.variante.imitations;
        if (imitations != null && imitations.length > 0) {
            for (var j = 0; j < imitations.length; j++) {
                if (this.listeLignePeinture.findIndex(x => x == imitations[j].productId) == -1) {
                    this.listeLignePeinture.push(imitations[j].productId);
                    switch (imitations[j].productId) {
                        case "372":
                            this.listeLignePeintureSelect.push("Equinox Solid");
                            break;
                        case "373":
                            this.listeLignePeintureSelect.push("Equinox Waterbase");
                            break;
                    }
                }
            }
        }

        window.onpopstate = function () {
        };

        this.infoFormule = this.formule.colorInfo.name + " - " + this.formule.colorInfo.ownerName + " (" + this.formule.colorInfo.firstUsed + " - " + this.formule.colorInfo.lastUsed + ") - " + this.formule.colorInfo.originalType;
        this.nomFormule = (this.formule.formula.formulaName) ? this.formule.formula.formulaName : "";
        window.document.getElementById("MC-formule-detailGlobal-imgCouleur").style.backgroundImage = "url(" + this.formule.formula.colorOnDisplayUri + ")";

        if (this.formule.formula.formulaVersions && this.formule.formula.formulaVersions.length) {
            this.versionFormuleCourante = this.formule.formula.formulaVersions[0];
            if (this.versionFormuleCourante && this.versionFormuleCourante.primer && this.versionFormuleCourante.primer.layerName) {
                this.versionFormuleCourante.primer.layerName = this.surchargeNomPrimer(this.versionFormuleCourante.primer.layerName);
            }

            if (this.formule.formula.formulaVersions[0].layer1 && this.formule.formula.formulaVersions[0].layer1.components.length > 0) {
                this.coucheFormuleCourante = this.formule.formula.formulaVersions[0].layer1;
                this.activeCouche1 = "active";
                this.indexVersionFormuleCouranteCouche = 1;
            } else if (this.formule.formula.formulaVersions[0].layer2 && this.formule.formula.formulaVersions[0].layer2.components.length > 0) {
                this.coucheFormuleCourante = this.formule.formula.formulaVersions[0].layer2;
                this.activeCouche2 = "active";
                this.indexVersionFormuleCouranteCouche = 2;
            }
            //else {
            //    this.coucheFormuleCourante = this.formule.formula.formulaVersions[0].primer;
            //    this.activeCouchePrimer = "active";
            //}

            this.indexVersionFormuleCourante = 0;
        }

        this.generateQRCode();

        let tmp = this.coucheFormuleCourante;
        this.coucheFormuleCourantePAE = JSON.parse(JSON.stringify(tmp)); // deepclone
        this.haveDilutionPAE = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * ngOnDestroy
     */
    ngOnDestroy(): void {
        if (this.searchSub != null) this.searchSub.unsubscribe();
        if (this.QRCodeSub != null) this.QRCodeSub.unsubscribe();
        if (this.roleSub != null) this.roleSub.unsubscribe();
        if (this.categorySub != null) this.categorySub.unsubscribe();
        if (this.tarifSub != null) this.tarifSub.unsubscribe();
        if (this.paeSub != null) this.paeSub.unsubscribe();
        if (this.paeDillutionSub != null) this.paeDillutionSub.unsubscribe();
        if (this.paeGetDillutionSub != null) this.paeGetDillutionSub.unsubscribe();
    }


    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * SelectCouche
     * @param couche
     */
    SelectCouche(couche: number) {

        this.haveDilutionPAE = false;

        this.indexVersionFormuleCouranteCouche = couche;
        switch (couche) {
            case 0:
                this.coucheFormuleCourante = this.formule.formula.formulaVersions[this.indexVersionFormuleCourante].primer;
                this.activeCouchePrimer = "active";
                this.activeCouche1 = "";
                this.activeCouche2 = "";
                break;
            case 1:
                this.coucheFormuleCourante = this.formule.formula.formulaVersions[this.indexVersionFormuleCourante].layer1;
                this.activeCouchePrimer = "";
                this.activeCouche1 = "active";
                this.activeCouche2 = "";
                break;
            case 2:
                this.coucheFormuleCourante = this.formule.formula.formulaVersions[this.indexVersionFormuleCourante].layer2;
                this.activeCouchePrimer = "";
                this.activeCouche1 = "";
                this.activeCouche2 = "active";
                break;
        }
        this.generateQRCode();
        this.selectUniteFormule();

        let tmp = this.coucheFormuleCourante;
        this.coucheFormuleCourantePAE = JSON.parse(JSON.stringify(tmp)); // deepclone
        this.haveDilutionPAE = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * SelectVersion
     * @param indexVersion
     */
    SelectVersion(indexVersion: number) {

        this.versionFormuleCourante = this.formule.formula.formulaVersions[indexVersion];
        if (this.versionFormuleCourante && this.versionFormuleCourante.primer && this.versionFormuleCourante.primer.layerName) {
            this.versionFormuleCourante.primer.layerName = this.surchargeNomPrimer(this.versionFormuleCourante.primer.layerName);
        }

        if (this.formule.formula.formulaVersions[indexVersion].layer1 && this.formule.formula.formulaVersions[indexVersion].layer1.components.length > 0) {
            this.coucheFormuleCourante = this.formule.formula.formulaVersions[indexVersion].layer1;
            this.activeCouche1 = "active";
            this.activeCouche2 = "";
            this.activeCouchePrimer = "";
        } else if (this.formule.formula.formulaVersions[indexVersion].layer2 && this.formule.formula.formulaVersions[indexVersion].layer2.components.length > 0) {
            this.coucheFormuleCourante = this.formule.formula.formulaVersions[indexVersion].layer2;
            this.activeCouche1 = "";
            this.activeCouche2 = "active";
            this.activeCouchePrimer = "";
        }
        //else {
        //    this.coucheFormuleCourante = this.formule.formula.formulaVersions[indexVersion].primer;
        //    this.activeCouche1 = "";
        //    this.activeCouche2 = "";
        //    this.activeCouchePrimer = "active";
        //}
        this.indexVersionFormuleCourante = indexVersion;
        this.generateQRCode();
        this.selectUniteFormule();

        let tmp = this.coucheFormuleCourante;
        this.coucheFormuleCourantePAE = JSON.parse(JSON.stringify(tmp)); // deepclone
        this.haveDilutionPAE = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * SelectLignePeinture
     * @param event
     */
    SelectLignePeinture(event: any) {

        this.haveDilutionPAE = false;

        var productId = "";
        switch (event.value) {
            case "Equinox Solid":
                productId = "372";
                break;
            case "Equinox Waterbase":
                productId = "373";
                break;
        }

        this.openLoader();
        this.searchSub = this.apiService.searchFormuleMixitCloud(this.variantes.marketColorId, this.variante.number, this.country, this.langue, productId).subscribe(data => {
            this.formule = data;
            let res: SearchResultMixitCloud = new SearchResultMixitCloud();
            res.formule = data;
            if (data != null) {
                this.resultLigneFormule.emit(res);
                this.SelectVersion(0);
            }
            if (this.searchSub != null) this.searchSub.unsubscribe();
            this.closeLoader();
        },
        error => {
            console.log(error);
            if (this.searchSub != null) this.searchSub.unsubscribe();
            this.closeLoader();
        });

    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * selectUniteFormule
     */
    selectUniteFormule() {
        if (this.uniteSelected == "L") {
            this.densiteFormule = 1;
        } else {
            this.densiteFormule = this.coucheFormuleCourante.components[this.coucheFormuleCourante.components.length - 1].cumulativeValue / 1000;
        }

        if (this.coucheFormuleCourantePAE && this.haveDilutionPAE) {
            if (this.uniteSelected == "L") {
                this.densiteFormulePAE = 1;
            } else {
                this.densiteFormulePAE = this.coucheFormuleCourantePAE.components[this.coucheFormuleCourantePAE.components.length - 1].cumulativeValue / 1000;
            }
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * hideKeyboard
     */
    hideKeyboard() {
        document.getElementById("qte").blur();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * openLoader
     */
    openLoader() {
        let modal = document.getElementById("loadingModal");
        modal.style.display = "flex";
        if (document.activeElement instanceof HTMLElement)
            document.activeElement.blur();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * closeLoader
     */
    closeLoader() {
        let modal = document.getElementById("loadingModal");
        modal.style.display = "none";
    }


    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * surchargeNomPrimer
     * @param layerName 
     * @returns string
     */
    surchargeNomPrimer(layerName: string) {
        switch (layerName) {
            case "W---ADV":
            case "W------":
            case "Sous couche blanche L1":
                return "Sous couche blanche L1";
            case "W/G-ADV":
            case "W/G----":
            case "Sous couche gris clair L2":
                return "Sous couche gris clair L2";
            case "G---ADV":
            case "G------":
            case "Sous couche gris moyen L3":
                return "Sous couche gris moyen L3";
            case "G/B-ADV":
            case "G/B----":
            case "Sous couche gris foncé L4":
                return "Sous couche gris foncé L4";
            case "B---ADV":
            case "B------":
            case "Sous couche noir L5":
                return "Sous couche noir L5";
            default:
                return "Sous couche"
        }       
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * printForm
     */
    printForm() {

        setTimeout(function () {

            document.getElementById("ImgHeaderIWL").classList.add("noPrint");
            document.getElementById("contentMixitCloud").classList.add("printFormule");
            document.getElementsByClassName("mat-sidenav-content")[0].classList.add("printFormule");

            this.win = window.open("", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + (screen.width / 2) + ",height=" + (screen.height / 2) + ",top=" + (100) + ",left=" + (100));

            let printHtml = '<html><head><link rel="stylesheet" href="assets/Impression/ImpressionFormule.css"></head><body>';
            //let headerPrint = '<div class="headerPrint">' + document.getElementsByClassName("headerPrint")[0].innerHTML + '</div>';
            let reportHtml = '<div class="contentPrint">' + document.getElementsByClassName("glob")[0].innerHTML + '</div>';

            printHtml += /*headerPrint +*/ '<table><caption></caption><thead><tr><td> ' + "" + ' </td></tr></thead><tbody><tr><td>' + reportHtml + ' </td></tr></tbody><tfoot><tr><td></td></tr></tfoot></table></body><footer></footer></html>';
            this.win.document.write(printHtml);
            this.win.document.close();

            setTimeout(function () {
                this.win.print();
                this.win.close();
            }, 300);

            document.getElementById("ImgHeaderIWL").classList.remove("noPrint");
            document.getElementById("contentMixitCloud").classList.remove("printFormule");
            document.getElementsByClassName("mat-sidenav-content")[0].classList.remove("printFormule");

        }, 300);

        //document.getElementById("ImgHeaderIWL").classList.add("noPrint");
        //document.getElementById("contentMixitCloud").classList.add("printFormule");
        //document.getElementsByClassName("mat-sidenav-content")[0].classList.add("printFormule");

        //setTimeout(function () {
        //    window.print();
        //    document.getElementById("ImgHeaderIWL").classList.remove("noPrint");
        //    document.getElementById("contentMixitCloud").classList.remove("printFormule");
        //    document.getElementsByClassName("mat-sidenav-content")[0].classList.remove("printFormule");
        //}, 100);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * generateQRCode
     */
    generateQRCode() {
        this.infoQRCode = "@LACA@" + this.teinteMeresSelected.results[0].marketColorId + "#";
        this.infoQRCode += this.teinteMeresSelected.results[0].makeDescription + "#";
        this.infoQRCode += this.variantes.akzoCode + "#";
        this.infoQRCode += this.teinteMeresSelected.results[0].colorDescription + " " + this.versionFormuleCourante.versionIdentifier + "#";
        this.infoQRCode += "CST" + "#";
        this.infoQRCode += new Date(this.versionFormuleCourante.versionDate).toISOString().split('T')[0].replace(/-/gi, '') + "#";
        this.infoQRCode += this.lignePeinture
        if (this.versionFormuleCourante.isEasydose) {
            this.infoQRCode += "#" + "Easy Dose";
        }
        for (let i = 0; i < this.coucheFormuleCourante.components.length; i++) {
            this.infoQRCode += "#" + this.coucheFormuleCourante.components[i].code + "|" + this.coucheFormuleCourante.components[i].absoluteValue.toFixed(3);
        }
        this.QRCodeSub = this.apiService.generateQRCode(this.infoQRCode).subscribe(data => {
            this.qrcode = data;
            if (this.QRCodeSub != null) this.QRCodeSub.unsubscribe();
        },
            error => {
                console.log(error);
                if (this.QRCodeSub != null) this.QRCodeSub.unsubscribe();
            }
        );
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * openQrCode
     */
    openQrCode() {
        let modal = document.getElementById("Modal");
        modal.style.display = "block";
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * closeModal
     */
    closeModal() {
        let modal = document.getElementById("Modal");
        modal.style.display = "none";
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * openCategoryTarif
     */
    openCategoryTarif() {
        let modal = document.getElementById("ModalCategoryTarif");
        modal.style.display = "block";
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * closeCategoryTarif
     */
    closeCategoryTarif() {
        let modal = document.getElementById("ModalCategoryTarif");
        modal.style.display = "none";
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * statsLogFormule
     */
    statsLogFormule() {
        //this.statsLogCWTFormule = this.apiService.statsLogCWTFormule(this.formule. , "Equinox", this.reference.lignes[this.index].ilayer).subscribe(() => {
        //    if (this.statsLogCWTFormule != null) this.statsLogCWTFormule.unsubscribe();
        //},
        //    error => {
        //        console.log(error);
        //        if (this.statsLogCWTFormule != null) this.statsLogCWTFormule.unsubscribe();
        //    }
        //);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * initFooter
     */
    initFooter() {
        if (this.category == "") {
            setTimeout(function () { document.getElementsByClassName("formuleTabRowFooter")[0].classList.remove("active"); }, 100);
        } else {
            setTimeout(function () { document.getElementsByClassName("formuleTabRowFooter")[0].classList.add("active"); }, 100);
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * setCategoryCtc
     */
    setCategoryCtc(event: any) {

        this.category = event.value;
        if (this.category == "") {
            this.displayedColumns = ["code", "name", /*"volume",*/ "weight", "cumul"];
            setTimeout(function () { document.getElementsByClassName("formuleTabRowFooter")[0].classList.remove("active"); }, 100);
        } else {
            this.displayedColumns = ["code", "name", /*"volume",*/ "weight", "cumul", "prix"];
            setTimeout(function () { document.getElementsByClassName("formuleTabRowFooter")[0].classList.add("active"); }, 100);
        }
        this.categorySub = this.apiService.setCategoryCtcEquinox(this.formule, this.category).subscribe(data => {

            this.formule = data;
            let res: SearchResultMixitCloud = new SearchResultMixitCloud();
            res.formule = data;
            if (data != null) {
                this.resultLigneFormule.emit(res);

                switch (this.indexVersionFormuleCouranteCouche) {
                    case 0:
                        this.coucheFormuleCourante = this.formule.formula.formulaVersions[this.indexVersionFormuleCourante].primer;
                        break;
                    case 1:
                        this.coucheFormuleCourante = this.formule.formula.formulaVersions[this.indexVersionFormuleCourante].layer1;
                        break;
                    case 2:
                        this.coucheFormuleCourante = this.formule.formula.formulaVersions[this.indexVersionFormuleCourante].layer2;
                        break;
                }

                //this.SelectVersion(0);
            }

            //this.index = this.reference.lignes.findIndex(f => f.numFormule == this.referenceDet.currentReference.formuleNum);
            //if (this.index < 0)
            //    this.index = 0;
            //this.ligne = data[this.index];
            let tmp = this.coucheFormuleCourante;
            this.coucheFormuleCourantePAE = JSON.parse(JSON.stringify(tmp)); // deepclone
            this.haveDilutionPAE = false;
            //this.effect = this.ligne.effect;
            //this.reference.formuleNum = this.reference.lignes[this.index].numFormule;

            //this.compute();
            this.statsLogFormule();
            this.generateQRCode();
            this.closeCategoryTarif();

            if (this.categorySub != null) this.categorySub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.categorySub != null) this.categorySub.unsubscribe();
        });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * setCategoryGeneriqueCtc
     */
    setCategoryGeneriqueCtc(event: any) {

        this.category = event.value;
        if (this.category == "") {
            this.displayedColumns = ["code", "name", /*"volume",*/ "weight", "cumul"];
            setTimeout(function () { document.getElementsByClassName("formuleTabRowFooter")[0].classList.remove("active"); }, 100);
        } else {
            this.displayedColumns = ["code", "name", /*"volume",*/ "weight", "cumul", "prix"];
            setTimeout(function () { document.getElementsByClassName("formuleTabRowFooter")[0].classList.add("active"); }, 100);
        }
        this.categorySub = this.apiService.setCategoryCtcEquinox(this.formule, this.category).subscribe(data => {

            this.formule = data;
            let res: SearchResultMixitCloud = new SearchResultMixitCloud();
            res.formule = data;
            if (data != null) {
                this.resultLigneFormule.emit(res);

                switch (this.indexVersionFormuleCouranteCouche) {
                    case 0:
                        this.coucheFormuleCourante = this.formule.formula.formulaVersions[this.indexVersionFormuleCourante].primer;
                        break;
                    case 1:
                        this.coucheFormuleCourante = this.formule.formula.formulaVersions[this.indexVersionFormuleCourante].layer1;
                        break;
                    case 2:
                        this.coucheFormuleCourante = this.formule.formula.formulaVersions[this.indexVersionFormuleCourante].layer2;
                        break;
                }

                //this.SelectVersion(0);
            }

            //this.index = this.reference.lignes.findIndex(f => f.numFormule == this.referenceDet.currentReference.formuleNum);
            //if (this.index < 0)
            //    this.index = 0;
            //this.ligne = data[this.index];
            let tmp = this.coucheFormuleCourante;
            this.coucheFormuleCourantePAE = JSON.parse(JSON.stringify(tmp)); // deepclone
            this.haveDilutionPAE = false;
            //this.effect = this.ligne.effect;
            //this.reference.formuleNum = this.reference.lignes[this.index].numFormule;

            //this.compute();

            this.statsLogFormule();
            this.generateQRCode();
            this.closeCategoryTarif();
            if (this.categorySub != null) this.categorySub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.categorySub != null) this.categorySub.unsubscribe();
        });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * prixLitreTotal
     */
    prixLitreTotal() {
        return this.coucheFormuleCourante.components.reduce((cumul, courant) => cumul + Utils.roundDecimal(courant.prixAuLitre * (((courant.absoluteValue * this.qte / this.densiteFormule) / courant.density) / 1000), 2), 0);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * openChoixPAE_DLL
     */
    openChoixPAE_DLL() {
        let language = this.storage.get("actualLanguage");
        this.choixDilutionVernisPAE = null;
        this.haveDilutionPAEDetailTitre = "";
        this.haveDilutionPAE = false;
        this.coucheFormuleCourantePAE = null;
        let tmp = this.coucheFormuleCourante;
        this.coucheFormuleCourantePAE = JSON.parse(JSON.stringify(tmp)); // deepclone
        // init de du retour de DLL
        this.paeSub = this.apiService.getRetourDLLPAEEquinox(this.coucheFormuleCourantePAE, this.lignePeinture == "Equinox Solid" ? 116 : 115, this.teinteMeresSelected.results[0].makeDescription, language, false).subscribe(data => {
            this.retour_DLL_PAE_initial = data;
            this.retour_DLL_PAE = data;
            var isFirstCoucheMulti = false;
            // execute les première étapes de la dll
            this.paeDillutionSub = this.apiService.traitementEtapeDillution(this.retour_DLL_PAE, language.split('-')[0].toLowerCase(), isFirstCoucheMulti).subscribe(dataDillution => {
                this.retour_DLL_PAE = dataDillution;
                // si le traitement de la dll est terminer => récupération via la clé de dillution des informations associé
                if (this.retour_DLL_PAE.etapeDLL == "end") {
                    if (this.retour_DLL_PAE.psDilution != "" && this.retour_DLL_PAE.psDilution != "-1") {
                        this.GetDillutionPAE();
                    } else {
                        this.closeChoixPAE_DLL();
                    }
                } else {
                    //sinon, si étape 's10.2' => demande 'list_st_retour_choix_vernis' dans 'st_retour_choix_vernis'
                    //if (this.retour_DLL_PAE.etapeDLL == "s10.2") {
                    //    this.listChoixVernis = this.retour_DLL_PAE.list_st_retour_choix_vernis;
                    //    this.seeListChoixVernis = true;
                    //} else {
                        this.closeChoixPAE_DLL();
                    //}
                }
            }, error => {
                console.log(error);
                if (this.paeDillutionSub != null) this.paeDillutionSub.unsubscribe();
            });
            if (this.paeSub != null) this.paeSub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.paeSub != null) this.paeSub.unsubscribe();
        });
        let modal = document.getElementById("ModalDLL_PAE");
        modal.style.display = "block";
    }

    ///* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    ///**
    // * traitementEtapeDillution_s10_2
    // */
    //traitementEtapeDillution_s10_2(choixVernis: string) {
    //    let language = this.storage.get("actualLanguage");
    //    this.retour_DLL_PAE.st_retour_choix_vernis = choixVernis;
    //    this.choixVernisPAE = choixVernis;
    //    this.paeDillutionSub = this.apiService.traitementEtapeDillution(this.retour_DLL_PAE, language.split('-')[0].toLowerCase(), false).subscribe(data => {
    //        console.log("traitementEtapeDillution");
    //        console.log(data);
    //        this.retour_DLL_PAE_initial = data;
    //        this.retour_DLL_PAE = data;
    //        // si le traitement de la dll est terminer => récupération via la clé de dillution des informations associé
    //        if (this.retour_DLL_PAE.etapeDLL == "end") {
    //            if (this.retour_DLL_PAE.psDilution != "" && this.retour_DLL_PAE.psDilution != "-1") {
    //                this.GetDillutionPAE();
    //            } else {
    //                this.closeChoixPAE_DLL();
    //            }
    //        } else {
    //            this.closeChoixPAE_DLL();
    //        }
    //    }, error => {
    //        console.log(error);
    //        if (this.paeDillutionSub != null) this.paeDillutionSub.unsubscribe();
    //    });
    //}

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * GetDillutionPAE
     */
    GetDillutionPAE() {
        let language = this.storage.get("actualLanguage");
        // récupération et affichage des informations associé à la dillution
        this.paeGetDillutionSub = this.apiService.getDillutionPAE(this.retour_DLL_PAE.psDilution, language.split('-')[0].toLowerCase(), "", true).subscribe(dataGetDillution => {
            ///*----------------------------------------------------------------------------------------------------*/console.log("getDillutionPAE");
            ///*----------------------------------------------------------------------------------------------------*/console.log(dataGetDillution);
            for (let i = 0; i < dataGetDillution.length; i++) {
                dataGetDillution[i].bdensite = parseFloat(dataGetDillution[i].bdensite.toFixed(3));
            }

            for (let i = 0; i < this.coucheFormuleCourantePAE.components.length; i++) {
                this.coucheFormuleCourantePAE.components[i].density = parseFloat(this.coucheFormuleCourantePAE.components[i].density.toFixed(3));

                //if (this.lignePAE.formule[i].bnum == "715" || this.coucheFormuleCourantePAE.components[i].tonerDescription == "VERNIS 1") {
                //    let tmpChoix = this.choixVernisPAE;
                //    let tmpElemIndex = dataGetDillution.findIndex(function (e, j) { return "" + e.bnum == tmpChoix; });
                //    if (tmpElemIndex > -1) {
                //        this.lignePAE.formule[i].bnum = "" + dataGetDillution[tmpElemIndex].bnum;
                //        this.lignePAE.formule[i].code = dataGetDillution[tmpElemIndex].bcode;
                //        this.lignePAE.formule[i].name = dataGetDillution[tmpElemIndex].bnom;
                //        this.lignePAE.formule[i].densite = dataGetDillution[tmpElemIndex].bdensite;
                //        this.lignePAE.formule[i].bintervientdansproduit = 1;
                //        this.lignePAE.formule[i].typesol = 0;
                //        this.lignePAE.formule[i].prixAuLitre = dataGetDillution[tmpElemIndex].prixAuLitre;
                //        dataGetDillution[tmpElemIndex].bnum = 0;
                //    }
                //}

            }
            let nivsuivant = -1;
            // stock le retour initial dans ixellColorWebPAE
            this.ixellColorWebPAE = dataGetDillution;
            // masque la selection des vernis et affiche la selection des étapes de dilution
            this.seeColorWebPAE = true;
            this.seeListChoixVernis = false;
            // affiche / masque les bouton d'étapes
            this.buttonCloseDilution = true;
            this.buttonPrevDilution = false;
            this.buttonNextDilution = false;
            // la liste des choix courant est initialiser au niveau 1
            this.ixellColorWebPAECourant = dataGetDillution.filter(function (e, i) { return e.niv == 1; });
            this.ixellColorWebPAECourant = this.ixellColorWebPAECourant.sort((a, b) => a.rang - b.rang);
            // le choix suivant prend pour valeur le nivsuivant du premier choix de la liste (permet d'initialiser le nvsuivant si on entre dans la boucle while ou de bloquer si == 0)
            nivsuivant = this.ixellColorWebPAECourant[0].nivsuivant;
            // tant qu'on a un seul choix possible, on ajoute le choix au différentes liste et on passe au choix suivant (breakLoopWhile pour éviter les boucles infini)
            var breakLoopWhile = 0;

            this.haveDilutionPAE_quadrillage = this.lignePeinture != "Equinox Solid" && this.ixellColorWebPAECourant[0].niv > 2;
            this.haveDilutionPAE_vehicule = this.lignePeinture == "Equinox Solid" && this.ixellColorWebPAECourant[0].niv > 1 && this.ixellColorWebPAECourant[0].titre1 == "Surface";

            while (this.ixellColorWebPAECourant != null && this.ixellColorWebPAECourant.length == 1 && nivsuivant != 0 && breakLoopWhile < 10) {
                // on ajout le choix courant dans la liste des sélectionner
                this.listChoixIxellColorWebPAE.push(this.ixellColorWebPAECourant[0]);
                // le choix suivant prend pour valeur le nivsuivant du premier choix de la liste (un seul choix possible car boucle while break sur this.ixellColorWebPAECourant.length != 1)
                nivsuivant = this.ixellColorWebPAECourant[0].nivsuivant;
                // on ajout le niv du choix courant dans la liste id précédent
                this.listIdIxellColorWebPAEPrecedent.push(this.ixellColorWebPAECourant[0].niv);
                // le choix courant passe au suivant
                this.ixellColorWebPAECourant = dataGetDillution.filter(function (e, i) { return e.niv == nivsuivant; });
                this.ixellColorWebPAECourant = this.ixellColorWebPAECourant.sort((a, b) => a.rang - b.rang);
                // affiche / masque les bouton d'étapes
                this.buttonCloseDilution = false;
                this.buttonPrevDilution = true;
                this.buttonNextDilution = false;

                if (this.ixellColorWebPAECourant && this.ixellColorWebPAECourant.length > 0) {
                    this.haveDilutionPAE_quadrillage = this.lignePeinture != "Equinox Solid" && this.ixellColorWebPAECourant[0].niv > 2;
                    this.haveDilutionPAE_vehicule = this.lignePeinture == "Equinox Solid" && this.ixellColorWebPAECourant[0].niv > 1 && this.ixellColorWebPAECourant[0].titre1 == "Surface";
                }
                if (this.haveDilutionPAE_vehicule) {
                    this.GetVehiculeDilutionPAEEquinox();
                }

                breakLoopWhile++;
            }
            // si nivsuivant == 0 => fin de la sélection des étapes de dilution
            if (nivsuivant == 0) {
                // vide la liste de selection possible car fin de dilution
                this.ixellColorWebPAECourant = [];
                // affiche / masque les bouton d'étapes
                this.buttonNextDilution = true;
            }
            this.writeSubtitlePAE_DLL();
        }, error => {
            console.log(error);
            if (this.paeGetDillutionSub != null) this.paeGetDillutionSub.unsubscribe();
        });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * GetOptionDillutionPAEEquinox
     * @param rang
     */
    GetOptionDillutionPAEEquinox(rang: number) {
        var choix: IxellColorWebPAE = this.ixellColorWebPAECourant.find(x => x.rang == rang);
        if (choix) {
            this.GetOptionDillutionPAE(choix);
        } else {
            this.prevChoixPAE_DLL();
            var choix: IxellColorWebPAE = this.ixellColorWebPAECourant.find(x => x.rang == rang);
            this.GetOptionDillutionPAE(choix);
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * GetVehiculeDilutionPAEEquinox
     */
    GetVehiculeDilutionPAEEquinox() {
        this.listChoixIxellColorWebPAEVehicule = [];
        if (this.ixellColorWebPAECourant != null && this.ixellColorWebPAECourant.length > 0) {
            // boucle sur les choix courant puis 2nd boucle sur les occurence suivante de chaque choix => permet de lister sur 2 niveau les occurence pour pouvoir afficher le PAE via vehicule
            for (var i = 0; i < this.ixellColorWebPAECourant.length; i++) {
                var nivSuivantVehicule = this.ixellColorWebPAECourant[i].nivsuivant;
                var temperatureVehicule = this.ixellColorWebPAE.filter(function (e, k) { return e.niv == nivSuivantVehicule; });
                // 2nd boucle sur les occurence suivante de chaque choix
                for (var j = 0; j < temperatureVehicule.length; j++) {

                    // si la ligne a deja été ajouter, on la complète avec les infos récupérer
                    if (this.listChoixIxellColorWebPAEVehicule.findIndex(x => x.titreRow == temperatureVehicule[j].messagesol1) > -1) {
                        var index = this.listChoixIxellColorWebPAEVehicule.findIndex(x => x.titreRow == temperatureVehicule[j].messagesol1);
                        switch (this.ixellColorWebPAECourant[i].rang) {
                            case 1: // unique
                                this.listChoixIxellColorWebPAEVehicule[index].unique = temperatureVehicule[j].titre1;
                                this.listChoixIxellColorWebPAEVehicule[index].idSolutionUnique = temperatureVehicule[j].idsolution;
                                break;
                            case 2: // lateral
                                this.listChoixIxellColorWebPAEVehicule[index].lateral = temperatureVehicule[j].titre1;
                                this.listChoixIxellColorWebPAEVehicule[index].idSolutionLateral = temperatureVehicule[j].idsolution;
                                break;
                            case 3: // demi
                                this.listChoixIxellColorWebPAEVehicule[index].demi = temperatureVehicule[j].titre1;
                                this.listChoixIxellColorWebPAEVehicule[index].idSolutionDemi = temperatureVehicule[j].idsolution;
                                break;
                            case 4: // complet
                                this.listChoixIxellColorWebPAEVehicule[index].complet = temperatureVehicule[j].titre1;
                                this.listChoixIxellColorWebPAEVehicule[index].idSolutionComplet = temperatureVehicule[j].idsolution;
                                break;
                        }
                    } else {
                        // si la ligne n'a pas deja été ajouter, on l'initialise avec les infos récupérer
                        var dilutionPAEEquinox: DilutionPAEEquinox = new DilutionPAEEquinox();
                        dilutionPAEEquinox.titreRow = temperatureVehicule[j].messagesol1;
                        dilutionPAEEquinox.idSolution = this.ixellColorWebPAECourant[i].idsolution;
                        dilutionPAEEquinox.rang = temperatureVehicule[j].rang;
                        switch (this.ixellColorWebPAECourant[i].rang) {
                            case 1: // unique
                                dilutionPAEEquinox.unique = temperatureVehicule[j].titre1;
                                dilutionPAEEquinox.idSolutionUnique = temperatureVehicule[j].idsolution;
                                break;
                            case 2: // lateral
                                dilutionPAEEquinox.lateral = temperatureVehicule[j].titre1;
                                dilutionPAEEquinox.idSolutionLateral = temperatureVehicule[j].idsolution;
                                break;
                            case 3: // demi
                                dilutionPAEEquinox.demi = temperatureVehicule[j].titre1;
                                dilutionPAEEquinox.idSolutionDemi = temperatureVehicule[j].idsolution;
                                break;
                            case 4: // complet
                                dilutionPAEEquinox.complet = temperatureVehicule[j].titre1;
                                dilutionPAEEquinox.idSolutionComplet = temperatureVehicule[j].idsolution;
                                break;
                        }
                        this.listChoixIxellColorWebPAEVehicule.push(dilutionPAEEquinox);
                    }
                }
            }
        }
        this.listChoixIxellColorWebPAEVehicule = this.listChoixIxellColorWebPAEVehicule.sort((a, b) => a.rang - b.rang);

        // on boucle sur chaque ligne pour fusionner les cellules si jamais plusieurs de suite on la même valeur
        for (var i = 0; i < this.listChoixIxellColorWebPAEVehicule.length; i++) {
            var tmp = this.listChoixIxellColorWebPAEVehicule[i];
            // cellule de titre 
            var titreRow: RowDilutionPAEEquinox = new RowDilutionPAEEquinox();
            titreRow.rowspan = 1
            titreRow.classspan = "rightMargin";
            titreRow.cellvalue = tmp.titreRow;
            titreRow.cellspan = 1;
            this.listChoixIxellColorWebPAEVehicule[i].rowDilutionPAEEquinox.push(titreRow);

            // cellule suivante
            var tmpRow: RowDilutionPAEEquinox = new RowDilutionPAEEquinox();
            tmpRow.rowspan = 1
            tmpRow.classspan = "centerMargin" + " " + tmp.unique.replace(" ", "");
            tmpRow.cellvalue = tmp.unique;
            var cellspan = 1;
            // si la cellule 1 est identique à la cellule 2
            if (tmp.unique == tmp.lateral) {
                // modification de la valeur de la cellule pour la dernière valeur connue + augmentation de la taille de la cellule
                tmpRow.cellvalue = tmp.lateral;
                cellspan++;
            } else {
                // initialisation des infos de la cellule pour ajout
                tmpRow.cellspan = cellspan;
                tmpRow.cellvalue = tmp.unique;
                tmpRow.zoneApplication = tmp.idSolution
                tmpRow.degreApplication = tmp.idSolutionUnique;
                // ajout de la cellule + pre initialisation des infos de la prochaine cellule
                this.listChoixIxellColorWebPAEVehicule[i].rowDilutionPAEEquinox.push(tmpRow);
                tmpRow = new RowDilutionPAEEquinox();
                tmpRow.rowspan = 1
                tmpRow.classspan = "centerMargin" + " " + tmp.lateral.replace(" ", "");
                tmpRow.cellvalue = tmp.lateral;
                cellspan = 1;
            }
            // si la cellule 2 est identique à la cellule 3
            if (tmp.lateral == tmp.demi) {
                // modification de la valeur de la cellule pour la dernière valeur connue + augmentation de la taille de la cellule
                tmpRow.cellvalue = tmp.demi;
                cellspan++;
            } else {
                // initialisation des infos de la cellule pour ajout
                tmpRow.cellspan = cellspan;
                tmpRow.cellvalue = tmp.lateral;
                tmpRow.zoneApplication = tmp.idSolution
                tmpRow.degreApplication = tmp.idSolutionLateral;
                // ajout de la cellule + pre initialisation des infos de la prochaine cellule
                this.listChoixIxellColorWebPAEVehicule[i].rowDilutionPAEEquinox.push(tmpRow);
                tmpRow = new RowDilutionPAEEquinox();
                tmpRow.rowspan = 1
                tmpRow.classspan = "centerMargin" + " " + tmp.demi.replace(" ", "");
                tmpRow.cellvalue = tmp.demi;
                cellspan = 1;
            }
            // si la cellule 3 est identique à la cellule 4
            if (tmp.demi == tmp.complet) {
                // modification de la valeur de la cellule pour la dernière valeur connue + augmentation de la taille de la cellule
                tmpRow.cellvalue = tmp.complet;
                tmpRow.cellspan = cellspan;
                cellspan++;
            } else {
                // initialisation des infos de la cellule pour ajout
                tmpRow.cellspan = cellspan;
                tmpRow.cellvalue = tmp.demi;
                tmpRow.zoneApplication = tmp.idSolution
                tmpRow.degreApplication = tmp.idSolutionDemi;
                // ajout de la cellule + pre initialisation des infos de la prochaine cellule
                this.listChoixIxellColorWebPAEVehicule[i].rowDilutionPAEEquinox.push(tmpRow);
                tmpRow = new RowDilutionPAEEquinox();
                tmpRow.rowspan = 1
                tmpRow.classspan = "centerMargin" + " " + tmp.complet.replace(" ", "");
                tmpRow.cellvalue = tmp.complet;
                cellspan = 1;
            }

            // initialisation des infos de la cellule pour ajout
            tmpRow = new RowDilutionPAEEquinox();
            tmpRow.rowspan = 1
            tmpRow.classspan = "centerMargin" + " " + tmp.complet.replace(" ", "");
            tmpRow.cellvalue = tmp.complet;
            tmpRow.zoneApplication = tmp.idSolution
            tmpRow.degreApplication = tmp.idSolutionComplet;
            tmpRow.cellspan = cellspan;
            // ajout de la cellule
            this.listChoixIxellColorWebPAEVehicule[i].rowDilutionPAEEquinox.push(tmpRow);   
        }
    }


    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * selectDilutionPAE_vehicule
     * @param zoneApplication
     * @param degreApplication
     */
    selectDilutionPAE_vehicule(zoneApplication: number, degreApplication: number) {
        // click sur l'une des cellule tu PAE via véhicule
        // etape 1 : on récupère la valeur de la solution via l'id initialiser en amont (zoneApplication) + on sélectionne l'option trouver
        var choix: IxellColorWebPAE[] = this.ixellColorWebPAE.filter(function (e, i) { return e.idsolution == zoneApplication; });
        if (choix && choix.length > 0) {
            this.GetOptionDillutionPAE(choix[0], false);
            // etape 2 : on récupère la valeur de la solution via l'id initialiser en amont (degreApplication) + on sélectionne l'option trouver
            choix = this.ixellColorWebPAE.filter(function (e, i) { return e.idsolution == degreApplication; });
            if (choix && choix.length > 0) {
                this.GetOptionDillutionPAE(choix[0], false);
                // initialisation d'un boolean en cas de retour arrière pour dire à la fonction prevChoixPAE_DLL de boucler 1 fois (pour simuler le retour des 2 étapes initiliser ci-dessus)
                this.dilutionPAE_vehiculeSelected = true;
            }
        }
    }


    GetValueRatioOptionDillutionPAE() {
        // valeur saisie inferieur au min possible => modification de la valeur saisie par la valeur min 
        if (this.choixJaugeIxellColorWebPAE.ratioChoix < this.choixJaugeIxellColorWebPAE.ratio1) {
            this.choixJaugeIxellColorWebPAE.ratioChoix = this.choixJaugeIxellColorWebPAE.ratio1;
        }
        // valeur saisie supérieur au max possible => modification de la valeur saisie par la valeur max
        if (this.choixJaugeIxellColorWebPAE.ratioChoix > this.choixJaugeIxellColorWebPAE.ratio2) {
            this.choixJaugeIxellColorWebPAE.ratioChoix = this.choixJaugeIxellColorWebPAE.ratio2;
        }
        this.GetOptionDillutionPAE(this.choixJaugeIxellColorWebPAE, this.choixJaugeWithBoucleWhile, false);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * GetOptionDillutionPAE
     */
    GetOptionDillutionPAE(choix: IxellColorWebPAE, withBoucleWhile: boolean = true, withCompareRatio: boolean = true) {


        if (withCompareRatio && choix.ratio1 != choix.ratio2) {
            this.haveDilutionPAE_jauge = true;
            this.choixJaugeIxellColorWebPAE = choix;
            this.choixJaugeWithBoucleWhile = withBoucleWhile;
            return;
        } else {
            this.haveDilutionPAE_jauge = false;
        }

        // ajout le choix de séléection d'atapes à listChoixIxellColorWebPAE
        this.listChoixIxellColorWebPAE.push(choix);
        // récupération du n°suivant pour le choix des étapes
        let nivsuivant = choix.nivsuivant;
        // affiche / masque les bouton d'étapes
        this.buttonCloseDilution = false;
        this.buttonPrevDilution = true;
        this.buttonNextDilution = false;
        // affecte la numéro courant a la liste des choix précédent
        this.listIdIxellColorWebPAEPrecedent.push(choix.niv);
        // si le choix suivant est != 0 alors on a encore des étapes de dilution
        if (nivsuivant != 0) {
            // le choix courant devient le suivant
            this.ixellColorWebPAECourant = this.ixellColorWebPAE.filter(function (e, i) { return e.niv == choix.nivsuivant; });
            this.ixellColorWebPAECourant = this.ixellColorWebPAECourant.sort((a, b) => a.rang - b.rang);

            this.haveDilutionPAE_quadrillage = this.lignePeinture != "Equinox Solid" && this.ixellColorWebPAECourant[0].niv > 2;
            this.haveDilutionPAE_vehicule = this.lignePeinture == "Equinox Solid" && this.ixellColorWebPAECourant[0].niv > 1 && this.ixellColorWebPAECourant[0].titre1 == "Surface";

            if (this.haveDilutionPAE_vehicule) {
                this.GetVehiculeDilutionPAEEquinox();
            }

            if (withBoucleWhile) {
                // tant qu'on a un seul choix possible, on ajoute le choix au différentes liste et on passe au choix suivant (breakLoopWhile pour éviter les boucles infini)
                var breakLoopWhile = 0;
                while (this.ixellColorWebPAECourant != null && this.ixellColorWebPAECourant.length == 1 && nivsuivant != 0 && breakLoopWhile < 10) {
                    // on ajout le choix courant dans la liste des sélectionner
                    this.listChoixIxellColorWebPAE.push(this.ixellColorWebPAECourant[0]);
                    // le choix suivant prend pour valeur le nivsuivant du premier choix de la liste (un seul choix possible car boucle while break sur this.ixellColorWebPAECourant.length != 1)
                    nivsuivant = this.ixellColorWebPAECourant[0].nivsuivant;
                    // on ajout le niv du choix courant dans la liste id précédent
                    this.listIdIxellColorWebPAEPrecedent.push(this.ixellColorWebPAECourant[0].niv);
                    // le choix courant passe au suivant
                    this.ixellColorWebPAECourant = this.ixellColorWebPAE.filter(function (e, i) { return e.niv == nivsuivant });
                    this.ixellColorWebPAECourant = this.ixellColorWebPAECourant.sort((a, b) => a.rang - b.rang);

                    if (this.ixellColorWebPAECourant && this.ixellColorWebPAECourant.length > 0) {
                        this.haveDilutionPAE_quadrillage = this.lignePeinture != "Equinox Solid" && this.ixellColorWebPAECourant[0].niv > 2;
                        this.haveDilutionPAE_vehicule = this.lignePeinture == "Equinox Solid" && this.ixellColorWebPAECourant[0].niv > 1 && this.ixellColorWebPAECourant[0].titre1 == "Surface";
                    }

                    if (this.haveDilutionPAE_vehicule) {
                        this.GetVehiculeDilutionPAEEquinox();
                    }

                    breakLoopWhile++;
                }
            }
        }
        // si nivsuivant == 0 => fin de la sélection des étapes de dilution
        if (nivsuivant == 0) {
            // vide la liste de selection possible car fin de dilution
            this.ixellColorWebPAECourant = [];
            // affiche / masque les bouton d'étapes
            this.buttonNextDilution = true;
        }
        this.writeSubtitlePAE_DLL();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * prevChoixPAE_DLL
     */
    prevChoixPAE_DLL() {
        // on supprime le dernier ajout dans listIdIxellColorWebPAEPrecedent et on le place dans nivsuivant pour sélectionner le courant et nétoyer la liste de séléction du courant
        let nivsuivant = this.listIdIxellColorWebPAEPrecedent.pop();
        this.listChoixIxellColorWebPAE = this.listChoixIxellColorWebPAE.filter(function (e, i) { return e.niv != nivsuivant; });
        this.ixellColorWebPAECourant = this.ixellColorWebPAE.filter(function (e, i) { return e.niv == nivsuivant; });
        this.ixellColorWebPAECourant = this.ixellColorWebPAECourant.sort((a, b) => a.rang - b.rang);

        this.haveDilutionPAE_quadrillage = this.lignePeinture != "Equinox Solid" && this.ixellColorWebPAECourant[0].niv > 2;
        this.haveDilutionPAE_vehicule = this.lignePeinture == "Equinox Solid" && this.ixellColorWebPAECourant[0].niv > 1 && this.ixellColorWebPAECourant[0].titre1 == "Surface";

        if (this.haveDilutionPAE_vehicule) {
            this.GetVehiculeDilutionPAEEquinox();
        } 

        // tant qu'on a un seul choix possible, on supprime le dernier ajout dans listIdIxellColorWebPAEPrecedent et on le place dans nivsuivant pour sélectionner le courant et nétoyer la liste de séléction du courant (breakLoopWhile pour éviter les boucles infini)
        var breakLoopWhile = 0;
        while (this.ixellColorWebPAECourant != null && this.ixellColorWebPAECourant.length == 1 && breakLoopWhile < 10) {
            let nivsuivant = this.listIdIxellColorWebPAEPrecedent.pop();
            this.listChoixIxellColorWebPAE = this.listChoixIxellColorWebPAE.filter(function (e, i) { return e.niv != nivsuivant; });
            this.ixellColorWebPAECourant = this.ixellColorWebPAE.filter(function (e, i) { return e.niv == nivsuivant; });
            this.ixellColorWebPAECourant = this.ixellColorWebPAECourant.sort((a, b) => a.rang - b.rang);

            if (this.ixellColorWebPAECourant && this.ixellColorWebPAECourant.length > 0) {
                this.haveDilutionPAE_quadrillage = this.lignePeinture != "Equinox Solid" && this.ixellColorWebPAECourant[0].niv > 2;
                this.haveDilutionPAE_vehicule = this.lignePeinture == "Equinox Solid" && this.ixellColorWebPAECourant[0].niv > 1 && this.ixellColorWebPAECourant[0].titre1 == "Surface";

                if (this.haveDilutionPAE_vehicule) {
                    this.GetVehiculeDilutionPAEEquinox();
                }
            } else {
                this.closeChoixPAE_DLL();
            }
        }

        // selon l'étape de la sélection, on affiche / masque les boutons d'étapes
        if (this.listIdIxellColorWebPAEPrecedent.length == 0) {
            this.buttonCloseDilution = true;
            this.buttonPrevDilution = false;
        } else {
            this.buttonCloseDilution = false;
            this.buttonPrevDilution = true;
        }
        // on masque systématiquement le bouton "suivant" car on est obligatoirement plus à la dernière étapes
        this.buttonNextDilution = false;

        this.writeSubtitlePAE_DLL();

        // si on est passer par la dilution via véhicule on a passer 2 étapes donc on revien de 2 étapes en arrière
        if (this.dilutionPAE_vehiculeSelected) {
            this.dilutionPAE_vehiculeSelected = false;
            this.prevChoixPAE_DLL();
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * writeSubtitlePAE_DLL
     */
    writeSubtitlePAE_DLL() {
        this.subtitlePAEDLL = "";
        for (let i = 0; i < this.listChoixIxellColorWebPAE.length; i++) {

            if (this.listChoixIxellColorWebPAE[i].messagesol1) {
                this.subtitlePAEDLL += " " + this.listChoixIxellColorWebPAE[i].messagesol1 + " /";
            } else if (this.listChoixIxellColorWebPAE[i].titre1) {
                this.subtitlePAEDLL += " " + this.listChoixIxellColorWebPAE[i].titre1 + " /";
            } else if (this.listChoixIxellColorWebPAE[i].bnom) {
                this.subtitlePAEDLL += " " + this.listChoixIxellColorWebPAE[i].bnom + " [" + this.listChoixIxellColorWebPAE[i].bcode + "]" + " /";
            }

        }

        if (this.subtitlePAEDLL.length > 1) {
            this.subtitlePAEDLL = this.subtitlePAEDLL.substring(0, this.subtitlePAEDLL.length - 1);
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * nextChoixPAE_DLL
     */
    nextChoixPAE_DLL() {

        for (let i = 0; i < this.coucheFormuleCourantePAE.components.length; i++) {
            var tmpdensite = parseFloat(this.coucheFormuleCourantePAE.components[i].density.toFixed(3));
            this.coucheFormuleCourantePAE.components[i].density = tmpdensite;
            var tmpWeight = parseFloat(this.coucheFormuleCourantePAE.components[i].absoluteValue.toFixed(3));
            this.coucheFormuleCourantePAE.components[i].absoluteValue = tmpWeight;
            var tmpvolume = parseFloat(this.coucheFormuleCourantePAE.components[i].volume.toFixed(3));
            this.coucheFormuleCourantePAE.components[i].volume = tmpvolume;
        }

        let recalculQte = 0;
        for (let i = 0; i < this.coucheFormuleCourantePAE.components.length; i++) {
            //this.coucheFormuleCourantePAE.components[i].bintervientdansproduit = 1;
            //this.coucheFormuleCourantePAE.components[i].typesol = 0;
            recalculQte += this.coucheFormuleCourantePAE.components[i].density > 0
                ? parseFloat(this.coucheFormuleCourantePAE.components[i].absoluteValue.toFixed(1)) / this.coucheFormuleCourantePAE.components[i].density / 1000
                : parseFloat(this.coucheFormuleCourantePAE.components[i].absoluteValue.toFixed(1)) / 1000;
        }
        recalculQte = recalculQte == 0 ? 1 : recalculQte;
        for (let i = 0; i < this.coucheFormuleCourantePAE.components.length; i++) {
            this.coucheFormuleCourantePAE.components[i].absoluteValue = this.coucheFormuleCourantePAE.components[i].absoluteValue / recalculQte;
        }

        var QteTeinteGramme = 0;
        let bGrammeUniquement = true;
        let volNonPAEGramme = 0;
        let volPrecedentGramme = 0;
        let volTotalGramme = 0;
        let volNonPAE = 0;
        let volPrecedent = 0;
        let vol = 0;
        let volFormule = 0;
        let qteGrammeFormule = 0;
        this.coucheFormuleCourantePAE.components.forEach(function (v) { qteGrammeFormule += v.absoluteValue; });
        let densiteFormule = parseFloat((qteGrammeFormule / 1000).toFixed(3));

        for (let i = 0; i < this.listChoixIxellColorWebPAE.length; i++) {
            let choixDilution = this.listChoixIxellColorWebPAE[i];
            if (choixDilution.bnum > 0) {
                // gramme ou %
                if (choixDilution.bvolume == 0) {
                    // si bvolume == 0 mais que codemethode == 0 => alors on est en % => calcul le ratio en g nécessaire
                    if (choixDilution.codemethode == 0) {
                        switch (choixDilution.cleappli) {
                            case 0:
                                // Hors PAE
                                choixDilution.ratioChoix = volNonPAEGramme * choixDilution.ratioChoix / 100;
                                break;
                            case 1:
                                // Toutes bases précédentes
                                choixDilution.ratioChoix = volTotalGramme * choixDilution.ratioChoix / 100;
                                break;
                            case 2:
                                // Base précédente
                                choixDilution.ratioChoix = volPrecedentGramme * choixDilution.ratioChoix / 100;
                                break;
                        }
                    }
                    choixDilution.gramme = choixDilution.ratioChoix;
                    volPrecedentGramme = choixDilution.ratioChoix;
                    volTotalGramme += choixDilution.ratioChoix;

                    if (choixDilution.bintervientdansproduit == 1) {
                        volNonPAEGramme += choixDilution.volume;
                    }

                    if (choixDilution.bnum > 0 && choixDilution.bdensite > 0) {
                        choixDilution.ratioChoix = choixDilution.ratioChoix / 1000 / choixDilution.bdensite;
                    }

                } else {
                    bGrammeUniquement = false;
                }

                if (choixDilution.bvolume == 0) {
                    choixDilution.volume = choixDilution.ratioChoix;
                } else {
                    switch (choixDilution.codemethode) {
                        case 0:
                            switch (choixDilution.cleappli) {
                                case 0:
                                    choixDilution.volume = volNonPAE * choixDilution.ratioChoix / 100;
                                    break;
                                case 1:
                                    choixDilution.volume = vol * choixDilution.ratioChoix / 100;
                                    break;
                                case 2:
                                    choixDilution.volume = volPrecedent * choixDilution.ratioChoix / 100;
                                    break;
                            }
                            break;
                        case 1:
                            choixDilution.volume = choixDilution.ratioChoix;
                            break;
                    }
                }

            } else {

                if (choixDilution.typesol == 5) {

                    //if (choixDilution.bvolume == 0) {
                    //    //volPrecedentGramme = choixDilution.ratioChoix;
                    //    //volTotalGramme += choixDilution.ratioChoix;

                    //    if (choixDilution.bintervientdansproduit == 1) {
                    //        volNonPAEGramme += choixDilution.volume;
                    //    }

                    //    if (densiteFormule > 0) {
                    //        choixDilution.ratioChoix = choixDilution.ratioChoix / 1000 / densiteFormule;
                    //    } else {
                    //        choixDilution.ratioChoix = choixDilution.ratioChoix / 1000;
                    //    }
                    //}

                    //switch (choixDilution.codemethode) {
                    //    case 0:
                    //        // poucentage
                    //        switch (choixDilution.cleappli) {
                    //            case 0:
                    //                // Hors PAE
                    //                choixDilution.volume = volNonPAE * choixDilution.ratioChoix / 100
                    //                break;
                    //            case 1:
                    //                // Toutes bases précédentes
                    //                choixDilution.volume = volTotal * choixDilution.ratioChoix / 100
                    //                break;
                    //            case 2:
                    //                // Base précédente
                    //                choixDilution.volume = volPrecedent * choixDilution.ratioChoix / 100
                    //                break;
                    //        }
                    //        break;
                    //    case 1:
                    //        // Part
                    //        choixDilution.volume = choixDilution.ratioChoix;
                    //        break;
                    //}
                } else {
                    // Laque
                    if (choixDilution.bvolume == 0) {
                        volTotalGramme += choixDilution.ratioChoix;
                        volPrecedentGramme = choixDilution.ratioChoix;

                        if (choixDilution.bintervientdansproduit == 1) {
                            volNonPAEGramme += choixDilution.volume;
                        }

                        if (densiteFormule > 0) {
                            choixDilution.volume = choixDilution.ratioChoix / 1000 / densiteFormule;
                        } else {
                            choixDilution.volume = choixDilution.ratioChoix / 1000;
                        }
                    } else {
                        choixDilution.volume = choixDilution.ratioChoix;
                    }
                    volFormule += choixDilution.volume;
                }

            }

            volPrecedent = choixDilution.volume;
            vol += choixDilution.volume;
            if (choixDilution.bintervientdansproduit == 1) {
                volNonPAE += choixDilution.volume;
            }
        }

        if (volNonPAE == 0) {
            volNonPAE = 1
        }
        if (volFormule == 0) {
            volFormule = 1
        }
        let volProp = volNonPAE;

        for (let i = 0; i < this.listChoixIxellColorWebPAE.length; i++) {
            let choixDilution = this.listChoixIxellColorWebPAE[i];
            if (choixDilution.bnum > 0 || choixDilution.typesol == 1 || choixDilution.typesol == 5) {
                switch (choixDilution.typesol) {
                    case 0:
                        if (choixDilution.bintervientdansproduit) {
                            if (volFormule > 0) {
                                if (bGrammeUniquement) { //QteTeinteGramme
                                    if (QteTeinteGramme > 0) { // Si l'on vient d'une formule
                                        choixDilution.gramme = choixDilution.gramme * qteGrammeFormule / QteTeinteGramme;
                                    }
                                    else { // Sinon ancien code pour gérer sous couche et vernis
                                        choixDilution.gramme = choixDilution.gramme / volFormule;
                                    }
                                } else {
                                    choixDilution.gramme = (choixDilution.volume * choixDilution.bdensite * 1000) / volFormule;
                                }
                            }
                        } else {
                            if (volProp > 0) {
                                if (bGrammeUniquement) { //QteTeinteGramme
                                    if (QteTeinteGramme > 0) {
                                        choixDilution.gramme = choixDilution.gramme * qteGrammeFormule / QteTeinteGramme;
                                    } else { // Sinon ancien code pour gérer sous couche et vernis
                                        choixDilution.gramme = choixDilution.gramme / volProp;
                                    }
                                } else {
                                    choixDilution.gramme = (choixDilution.volume * choixDilution.bdensite * 1000) / volProp;
                                }
                            }
                        }
                        break;
                    case 1:
                        break;
                    /*
                    CAS FORMULE_SECTION_MESSAGE: //********************************************************************
                        HLitRecherche(SOLUTIONS,ID_SOLUTION,TABLE_Dilution.COL_IdSolution[nInd],hIdentique)
                        SI HTrouve(SOLUTIONS) ALORS
                            HLitRecherche(TITRE_SOL,NUM_TITRE,SOLUTIONS.NUM_AFF,hIdentique)
                            SI HTrouve(TITRE_SOL) ALORS
                                pMaFormule:stTListeIngredient[nNbIngredient]:nIdMessage = SOLUTIONS.NUM_AFF
                                pMaFormule:stTListeIngredient[nNbIngredient]:sMessage = TITRE_SOL.TITRE[Langue.IDranglangue]
                                pMaFormule:stTListeIngredient[nNbIngredient]:nDelais = SOLUTIONS.DELAI_MESS
                            FIN
                        FIN
                    */
                    //case 2:
                    //    break;
                    //case 3:
                    //case 4:
                    //    break;
                    //case 5:
                    //    break;

                }
            } else {
                QteTeinteGramme += choixDilution.gramme;
            }

            if (choixDilution.bnum > 0 && (this.listChoixVernis.indexOf("" + choixDilution.bnum) == -1) && choixDilution.ratioChoix > 0) {
                let ingr: FormulaComponent = new FormulaComponent();
                //ingr.bnum = "" + choixDilution.bnum;
                ingr.code = choixDilution.bcode;
                ingr.tonerDescription = choixDilution.bnom;
                ingr.absoluteValue = choixDilution.gramme;
                ingr.volume = choixDilution.volume;
                ingr.density = choixDilution.bdensite;
                ingr.prixAuLitre = choixDilution.prixLitre;
                //ingr.bintervientdansproduit = choixDilution.bintervientdansproduit;
                //ingr.typesol = choixDilution.typesol;
                ingr.cumulativeValue = -2;
                this.coucheFormuleCourantePAE.components.push(ingr);
            }

        }

        let cumulFormulePAE = 0;
        let volumeTotal = 0;
        for (let i = 0; i < this.coucheFormuleCourantePAE.components.length; i++) {
            if (this.coucheFormuleCourantePAE.components[i].density > 0) {
                volumeTotal += this.coucheFormuleCourantePAE.components[i].absoluteValue / 1000 / this.coucheFormuleCourantePAE.components[i].density;
            } else {
                volumeTotal += this.coucheFormuleCourantePAE.components[i].absoluteValue / 1000;
            }
        }

        for (let i = 0; i < this.coucheFormuleCourantePAE.components.length; i++) {
            this.coucheFormuleCourantePAE.components[i].absoluteValue = this.coucheFormuleCourantePAE.components[i].absoluteValue / volumeTotal;
            cumulFormulePAE += parseFloat(this.coucheFormuleCourantePAE.components[i].absoluteValue.toFixed(1));
            this.coucheFormuleCourantePAE.components[i].cumulativeValue = cumulFormulePAE;
        }

        this.haveDilutionPAEDetailTitre = this.subtitlePAEDLL;

        this.haveDilutionPAE = true;

    if (this.uniteSelected == "L") {
        this.densiteFormulePAE = 1;
    } else {
        this.densiteFormulePAE = this.coucheFormuleCourantePAE.components[this.coucheFormuleCourantePAE.components.length - 1].cumulativeValue / 1000;
    }


        if (this.category) {
            setTimeout(function () { document.getElementsByClassName("formuleTabRowFooter")[1].classList.add("active"); }, 100);
        } else {
            setTimeout(function () { document.getElementsByClassName("formuleTabRowFooter")[1].classList.remove("active"); }, 100);
        }


        this.closeChoixPAE_DLL();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * closeChoixPAE_DLL
     */
    closeChoixPAE_DLL() {
        let modal = document.getElementById("ModalDLL_PAE");
        modal.style.display = "none";
        this.listChoixVernis = [];
        this.seeListChoixVernis = false;
        this.seeColorWebPAE = false;
        this.ixellColorWebPAE = [];
        this.ixellColorWebPAECourant = [];
        this.listChoixIxellColorWebPAE = [];
        this.listIdIxellColorWebPAEPrecedent = [];

        this.listChoixIxellColorWebPAEVehicule = [];

        this.buttonCloseDilution = true;
        this.buttonPrevDilution = false;
        this.buttonNextDilution = false;

        this.haveDilutionPAE_quadrillage = false;
        this.haveDilutionPAE_vehicule = false;
        this.haveDilutionPAE_jauge = false;
        this.dilutionPAE_vehiculeSelected = false;

        this.subtitlePAEDLL = "";
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * prixLitreTotalPAE
     */
    prixLitreTotalPAE() {
        return this.coucheFormuleCourantePAE.components.reduce((cumul, courant) => cumul + Utils.roundDecimal(courant.prixAuLitre * (((courant.absoluteValue * this.qte / this.densiteFormulePAE) / courant.density) / 1000), 2), 0);
    }

}
